import { MenuType } from "../enums";

export interface IMenuPatientModel {
    mainPage: string;
    subPage: string;
    category: string;
    url: string;
    count: number;
    priority: number;
    generalClasses: string;
    iconClasses: string;
    menuTypeId: MenuType;

    displayName: string;
    activeRoute: string;

    hasMarker?: boolean;
    isHovering?: boolean;

   
    id?: number;
    encryptedId?: string;
    name?: string;
    value?: string;
    optionalId?: number;
    optionalText?: string;
    optionalText1?: string;
    optionalText2?: string;
    optionalData?: number;
    cost?: number;
    isSelected?: boolean;
    color?: string;
    date?: Date;
    time?: object;
    status?: boolean;
    duration?: number;
    optionalId1?: number;
}










